<template>
  <div class="expense-list-item" @click="$emit('edit', item)">
    <div class="expense-list-item-info">
      <Tooltip :title="item.recipientName || (item.recipient && item.recipient.content) || ''">
        <div class="expense-list-item-recipient">{{ item.recipientName || (item.recipient && item.recipient.content) }}</div>
      </Tooltip>
      <div class="expense-list-item-description">{{ item.description }}</div>
    </div>

    <div class="expense-list-item-col expense-list-item-col-rent">
      <Badge
        v-if="item.rentId"
        :title="'Nº ' + (item.rent && item.rent.content)"
        type="primary"
        size="small"
      />
    </div>

    <div class="expense-list-item-col expense-list-item-col-date">
      <span v-if="item.dueDate" class="expense-list-item-date">
        <i class="fa-regular fa-calendar"></i>
        {{ item.dueDateStr }}
      </span>
    </div>

    <div class="expense-list-item-col expense-list-item-col-value">
      <span class="expense-list-item-value">{{ item.value | currency }}</span>
    </div>

    <div class="expense-list-item-col expense-list-item-col-status">
      <Badge
        v-if="item.statusName"
        :title="item.statusName"
        :type="statusType(item.statusName)"
        size="small"
      />
    </div>

    <div
      v-if="isApproved(item.statusName) && item.approvedBy"
      class="expense-list-item-col expense-list-item-col-approved"
    >
      <Badge
        :title="`Aprovado por: ${item.approvedBy}`"
        type="info"
        size="small"
        classIcon="fa-solid fa-user-check"
      />
    </div>

    <div class="expense-list-item-col expense-list-item-col-remove">
      <div
        v-if="canRemove(item.statusName)"
        class="expense-list-item-remove"
        @click.stop="onRemoveClick"
      >
        <Loading v-if="removing" type="bubbles" :center="false" :width="20" :height="20" />
        <i v-else class="fa-solid fa-trash"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Badge from "@/ui/layout/Badge.vue";
import Tooltip from "@/ui/layout/Tooltip.vue";
import Loading from "@/ui/shared/Loading.vue";
export default {
  name: "ExpenseRow",
  components: {
    Badge,
    Tooltip,
    Loading,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    removing: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onRemoveClick() {
      if (this.removing) return;
      this.$emit("remove", this.item);
    },
    canRemove(statusName) {
      if (!statusName) return true;
      const s = String(statusName).toLowerCase();
      return s !== "aprovada";
    },
    isApproved(statusName) {
      if (!statusName) return false;
      return String(statusName).toLowerCase() === "aprovada";
    },
    statusType(statusName) {
      if (!statusName) return "info";
      const s = String(statusName).toLowerCase();
      if (s === "aprovada") return "success";
      if (s === "reprovada" || s === "reprovado") return "danger";
      return "warning";
    },
  },
};
</script>

<style scoped>
.expense-list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
  border: 1px solid var(--border-subtle);
}

.expense-list-item:hover {
  background: var(--bg-hover);
}

.expense-list-item-info {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.expense-list-item-info >>> .nx-tooltip-trigger {
  display: block;
  min-width: 0;
}

.expense-list-item-col {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.expense-list-item-col-rent {
  width: 110px;
  justify-content: center;
}

.expense-list-item-col-date {
  width: 100px;
}

.expense-list-item-col-value {
  width: 80px;
  justify-content: flex-end;
}

.expense-list-item-col-status {
  width: 110px;
  justify-content: center;
}

.expense-list-item-col-approved {
  width: auto;
}

.expense-list-item-col-remove {
  width: 32px;
  justify-content: center;
}

.expense-list-item-recipient {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expense-list-item-description {
  font-size: 11px;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expense-list-item-date {
  font-size: 12px;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}

.expense-list-item-value {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-danger);
  white-space: nowrap;
  flex-shrink: 0;
}

.expense-list-item-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: var(--color-danger);
  cursor: pointer;
  transition: color 0.15s, opacity 0.15s;
  flex-shrink: 0;
}

.expense-list-item-remove:hover {
  opacity: 0.7;
}
</style>
